import React from "react";
import InfoCard from "../../Layout/DesignSystem/InfoCard/InfoCard";
import Formatter from "../../Data/Domain/Formatter";
import "./DashboardOffset.css";

const InfoCardsSection = ({ cards, year, isLoading }) => {
  const infoCardsData = [
    {
      key: 1,
      value: Formatter.formatNumber(cards.total_co2 || 0.0),
      title: `Total Emission ${year}`,
      unit: "ton CO₂",
      type: "blue-card",
    },
    {
      key: 2,
      value: Formatter.formatNumber(cards.emission_projected || 0.0),
      title: `Emission projected ${+year + 1}`,
      unit: "ton CO₂",
      type: "dark-green-card",
    },
    {
      key: 3,
      value: Formatter.formatNumber(cards.last_month_emission || 0.0),
      title: "Last month's emissions",
      unit: "ton CO₂",
      type: "dark-degraded-card",
    },
    {
      key: 4,
      value: Formatter.formatNumber(cards.emission_saving || 0.0),
      title: "Reductions",
      unit: "ton CO₂",
      type: "green-card",
    },
  ];

  return (
    <div className="info-card-container">
      {infoCardsData.map(({ key, ...statistic }) => (
        <div key={key} className="info-card-wrapper">
          <InfoCard statistic={statistic} isLoading={isLoading} />
        </div>
      ))}
    </div>
  );
};

export default InfoCardsSection;
